import { render, staticRenderFns } from "./stock_calculator.vue?vue&type=template&id=6b4ae21f&scoped=true"
import script from "./stock_calculator.vue?vue&type=script&lang=js"
export * from "./stock_calculator.vue?vue&type=script&lang=js"
import style0 from "./stock_calculator.vue?vue&type=style&index=0&id=6b4ae21f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ae21f",
  null
  
)

export default component.exports